import * as React from "react";

function Done(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 19 19" fill="none" {...props}>
      <path
        d="M14.104 6.313L7.73 12.688c-.92-.921-1.841-1.842-2.833-2.905"
        stroke="#64B622"
        strokeWidth={1.2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 18a8.5 8.5 0 100-17 8.5 8.5 0 000 17z"
        stroke="#64B622"
        strokeWidth={1.2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Done;
